import { APP_CONFIG } from "../AppConfig";
import { BaseService } from "./baseService";
import axios from "axios";

class IntakeFormService extends BaseService {
  async getIntakeFormById(clientId) {
    try {
      const url = APP_CONFIG.INTAKEFORM_URL;
      const data = await this.fetchData(url);
      return data;
    } catch (error) {
      console.error("Error fetching client list:", error);
      throw error;
    }
  }

  async getIntakeFormByClientId(clientId) {
    try {
      const url = APP_CONFIG.INTAKEFORM_URL;
      const data = await this.fetchData(`${url}/${clientId}`);
      return data;
    } catch (error) {
      console.error("Error fetching client list:", error);
      throw error;
    }
  }
  async getAccount() {
    try {
      const url = `${APP_CONFIG.CLIENT_URL}/profile`;
      const data = await this.fetchData(url);
      return data;
    } catch (error) {
      console.error("Error fetching client list:", error);
      throw error;
    }
  }
}

export default IntakeFormService;
